import { TranscriptSchema } from "../../schemas/transcript";
/**
 * Parse transcript from SRT subtitle format.
 * Speaker inferred from prefix in text ("Clinician:" or "Patient:").
 */
export function parseSrtTranscript(content) {
    const blocks = content.split(/\n\n+/);
    const entries = blocks
        .map(block => {
        const lines = block.split("\n").filter(Boolean);
        if (lines.length < 2)
            return null;
        const timeLine = lines[1];
        const match = timeLine.match(/(\d+):(\d+):(\d+),\d+\s*-->\s*(\d+):(\d+):(\d+),\d+/);
        let start;
        let end;
        if (match) {
            const [, h1, m1, s1, h2, m2, s2] = match.map(Number);
            start = h1 * 3600 + m1 * 60 + s1;
            end = h2 * 3600 + m2 * 60 + s2;
        }
        const text = lines.slice(2).join(" ");
        let speaker = "other";
        let cleanText = text;
        if (/^Clinician:/i.test(text)) {
            speaker = "clinician";
            cleanText = text.replace(/^Clinician:/i, "").trim();
        }
        else if (/^Patient:/i.test(text)) {
            speaker = "patient";
            cleanText = text.replace(/^Patient:/i, "").trim();
        }
        return { speaker, text: cleanText, start, end };
    })
        .filter(Boolean);
    return TranscriptSchema.parse({ entries });
}
